import { createTheme } from '@mui/material/styles';
import { ErrorColor, InfoColor, PrimaryColor, SuccessColor, WarningColor } from '@src/components/common/Colors';

// A custom theme for this app
const theme = createTheme({
  shape: {
    borderRadius: 6,
  },
  typography: {
    fontFamily: ['Figtree', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(','),
  },
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          // Mouse clicks still get no outline (avoids the "ugly square" complaint that motivated the old blanket
          // removal), but :focus-visible restores it for keyboard navigation - removing it outright made every
          // icon-only control (cart delete/edit/close, grid actions, product info) invisible to keyboard users.
          '&:focus': {
            outline: 'none',
          },
          '&:focus-visible': {
            outline: `2px solid ${PrimaryColor}`,
            outlineOffset: '2px',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0px 1px 3px rgba(15, 23, 42, 0.08), 0px 1px 2px rgba(15, 23, 42, 0.06)',
        },
      },
    },
  },
  palette: {
    primary: {
      main: PrimaryColor,
    },
    success: {
      main: SuccessColor,
    },
    warning: {
      main: WarningColor,
    },
    info: {
      main: InfoColor,
    },
    error: {
      main: ErrorColor,
    },
  },
});

export default theme;
